import ApiService from '../../../../shared/services/api-service';
import commonActions from '../../../../shared/store/common/action-creators';
import addressesActionsCreators from '../../addresses/action-creators';
import myDepartmentActionCreators from './my-department';
import notificationsActionsCreator from '../../notifications/action-creators';

const myDepartmentAddressesActionsCreators = {
  updateMyDepartmentAddresses(formData) {
    const patchData = {
      data: formData.addresses,
      patched: 'addresses',
    };
    return async (dispatch) => {
      dispatch(this.setIsLoading('updateMyDepartmentAddresses'));
      const data = await ApiService.patch('/api/v1/my-department', patchData)
        .then(response => response.data)
        .catch(error => ({ error }));
      dispatch(this.setIsLoading('updateMyDepartmentAddresses'));
      if (data.error) {
        dispatch(commonActions.handleApiError(data.error));
      } else {
        dispatch(this.updateMyDepartmentAddressesSuccess(data));
      }
    };
  },
  updateMyDepartmentAddressesSuccess(updated) {
    return (dispatch) => {
      dispatch(myDepartmentActionCreators.replaceMyDepartment(updated.data));
      // This action handles success for both add and edit, so make sure we dispatch
      //   to reset both related state keys
      dispatch(addressesActionsCreators.resetAddressState());
      dispatch(notificationsActionsCreator.addSavedSuccessfully('Addresses updated'))
    };
  },
};

export default myDepartmentAddressesActionsCreators;
